import { Navigate } from "react-router-dom";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";

interface FeatureFlagGuardProps {
  flagKey: string;
  redirectTo?: string;
  children: React.ReactNode;
}

export function FeatureFlagGuard({ flagKey, redirectTo = "/paths", children }: FeatureFlagGuardProps) {
  const { enabled, isLoading } = useFeatureFlag(flagKey);

  if (isLoading) return null;
  if (!enabled) return <Navigate to={redirectTo} replace />;

  return <>{children}</>;
}
